var _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReduceScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "full-screen-interface-symbol-of-four-arrows-in-square-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.448,
    height: 56.448,
    viewBox: "0 0 56.448 56.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32__4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3297",
    "data-name": "Path 3297",
    d: "M49.392,0H7.056A7.056,7.056,0,0,0,0,7.056V49.392a7.056,7.056,0,0,0,7.056,7.056H49.392a7.056,7.056,0,0,0,7.056-7.056V7.056A7.056,7.056,0,0,0,49.392,0ZM52.92,49.392a3.527,3.527,0,0,1-3.528,3.528H7.056a3.527,3.527,0,0,1-3.528-3.528V7.056A3.528,3.528,0,0,1,7.056,3.528H49.392A3.528,3.528,0,0,1,52.92,7.056Z",
    fill: "#ddd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M44.05,10.584H35.28a1.764,1.764,0,1,0,0,3.528h4.636L31.45,22.577l2.494,2.494,8.428-8.428-.037,4.525a1.764,1.764,0,0,0,3.528,0v-8.82a1.583,1.583,0,0,0-.557-1.235A1.759,1.759,0,0,0,44.05,10.584Z",
    transform: "translate(-21 20)",
    fill: "#ddd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M33.263,10.584h8.77a1.764,1.764,0,0,1,0,3.528H37.4l8.465,8.466-2.494,2.494-8.428-8.428.037,4.525a1.764,1.764,0,1,1-3.528,0v-8.82a1.583,1.583,0,0,1,.557-1.235A1.759,1.759,0,0,1,33.263,10.584Z",
    transform: "translate(0 20)",
    fill: "#ddd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M44.05,25.072H35.28a1.764,1.764,0,0,1,0-3.528h4.636L31.45,13.078l2.494-2.494,8.428,8.429-.037-4.525a1.764,1.764,0,1,1,3.528,0v8.82a1.584,1.584,0,0,1-.557,1.235A1.759,1.759,0,0,1,44.05,25.072Z",
    transform: "translate(-21)",
    fill: "#ddd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M33.263,25.072h8.77a1.764,1.764,0,0,0,0-3.528H37.4l8.465-8.466-2.494-2.494-8.428,8.429.037-4.525a1.764,1.764,0,1,0-3.528,0v8.82a1.584,1.584,0,0,0,.557,1.235A1.759,1.759,0,0,0,33.263,25.072Z",
    fill: "#ddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReduceScreen);
export default __webpack_public_path__ + "static/media/icon_reduceScreen.a383be81.svg";
export { ForwardRef as ReactComponent };